import React from 'react'
import Moon from './Moon'
import Desktop from './Desktop'
import ArrowRight from './ArrowRight'
import ArrowLeft from './ArrowLeft'
import ArrowDown from './ArrowDown'
import Bell from './Bell'
import DropdownIcon from './DropdownIcon'
import Home from './Home'
import MapPin from './MapPin'
import Menu from './Menu'
import OutlineCog from './OutlineCog'
import OutlinePerson from './OutlinePerson'
import OutlineLogout from './OutlineLogout'
import Sun from './Sun'
import User from './User'
import Video from './Video'
import Fire from './Fire'
import Pose from './Pose'
import Garbage from './Garbage'
import HandRaise from './HandRaise'
import ForeignObject from './ForeignObject'
import Danger from './Danger'
import Edit from './Edit'
import Delete from './Delete'
import Pause from './Pause'
import Play from './Play'
import Expand from './Expand'
import List from './List'
import Grid from './Grid'
import VerticalDots from './VerticalDots'
import Download from './Download'
import PlayButton from './PlayButton'
import Back from './Back'
import SitePin from './SitePin'
import Search from './Search'
import Add from './Add'
import Undo from './Undo'
import Vehicle from './Vehicle'
import PPE from './PPE'
import OnboardPPE from './OnboardPPE'
import Close from './Close'
import Eye from './Eye'
import EyeSlash from './EyeSlash'
import NoVideo from './NoVideo'
import Setting from './Setting'
import TotalAlerts from './TotalAlerts'
import IncidentRate from './IncidentRate'
import SafetyIcons from './SafetyIcons'
import HighestZone from './HighestZone'
import Reset from './Reset'
import Star from './Star'
import Check from './Check'
import Stop from './Stop'
import Crosshairs from './Crosshairs'
import EditRule from './EditRule'
import Assistant from './Assistant'
import Document from './Document'
import Image from './Image'
import Attachment from './Attachment'
import Send from './Send'
import Warning from './Warning'
import Doors from './Doors'
import Empty from './Empty'
import Count from './Count'
import Counts from './Counts'
import Trash from './Trash'
import Throwing from './Throwing'
import TwoDoors from './TwoDoors'
import Behaviour from './Behaviour'
import Reload from './Reload'
import Harness from './Harness'
import UnprotectedEdge from './UnprotectedEdge'
import GuardRail from './GuardRail'
import SafetyRail from './SafetyRail'
import CarryingLoads from './CarryingLoads'
import Tasks from './Tasks'
import FullCamera from './FullCamera'
import Water from './Water'
import Detection from './Detection'
import Camera from './Camera'
import Calendar from './Calendar'
import Notification from './Notification'
import Privacy from './Privacy'
import ChevronDown from './ChevronDown'
import VehicleDistance from './VehicleDistance'
import ErgonomyAnalysis from './ErgonomyAnalysis'
import Alert from './Alert'
import Users from './Users'
import Box from './Box'
import Archive from './Archive'
import Door from './Door'
import DoorOpen from './DoorOpen'
import Throw from './Throw'
import Behavior from './Behavior'
import Spill from './Spill'
import Stairs from './Stairs'
import CapacityViolation from './CapacityViolation'
import Rotate from './Rotate'
import Fullscreen from './Fullscreen'
import FullscreenExit from './FullscreenExit'

const Icons = {
  Reset,
  HighestZone,
  SafetyIcons,
  IncidentRate,
  TotalAlerts,
  Setting,
  NoVideo,
  Search,
  SitePin,
  Back,
  PlayButton,
  Download,
  VerticalDots,
  List,
  Grid,
  Play,
  Expand,
  Pause,
  Delete,
  Add,
  Undo,
  Edit,
  Fire,
  Pose,
  Garbage,
  HandRaise,
  ForeignObject,
  Danger,
  Moon,
  Desktop,
  Bell,
  ArrowDown,
  ArrowRight,
  ArrowLeft,
  DropdownIcon,
  Home,
  MapPin,
  Menu,
  OutlineCog,
  OutlinePerson,
  OutlineLogout,
  Sun,
  User,
  Video,
  Vehicle,
  PPE,
  OnboardPPE,
  Close,
  Eye,
  EyeSlash,
  Star,
  Check,
  EditRule,
  Assistant,
  Document,
  Image,
  Attachment,
  Send,
  Warning,
  Doors,
  Empty,
  Count,
  Counts,
  Trash,
  Throwing,
  TwoDoors,
  Behaviour,
  Reload,
  Harness,
  UnprotectedEdge,
  GuardRail,
  SafetyRail,
  CarryingLoads,
  Tasks,
  FullCamera,
  Water,
  Detection,
  Camera,
  Calendar,
  Notification,
  Privacy,
  ChevronDown,
  Stop,
  Crosshairs,
  VehicleDistance,
  ErgonomyAnalysis,
  Alert,
  Users,
  Box,
  Archive,
  Door,
  DoorOpen,
  Throw,
  Behavior,
  Spill,
  Stairs,
  CapacityViolation,
  Rotate,
  Fullscreen,
  FullscreenExit,
}
export function Icon({ icon, ...props }) {
  // temp icon for diff alerts models
  if ( icon === "Danger zone")
    icon = 'Danger'
  else if(icon === "Fire & Smoke")
    icon = 'Fire'
  else if(icon === "Vehicle to Pedestrian Distance")
    icon = 'Vehicle'
  const Icon = Icons[icon]
  if (!Icon) {
    // Fall back to a generic icon instead of throwing so an unmapped/new
    // model name (e.g. one added on the backend without a matching icon)
    // never takes down the whole page.
    console.error(`No icon named "${icon}", falling back to "Alert"`)
    return <Icons.Alert {...props} />
  }
  return <Icon {...props} />
}
export default Icons
